import { createContext, PropsWithChildren, useContext, useState } from "react";

type LineItemRejectReason = Record<string, { reason: string }>;

const LineItemsStateContext = createContext<
  | {
      lineItemsReason: LineItemRejectReason;
      addLineItemReason: (id: string) => (reason: string) => void;
    }
  | undefined
>(undefined);

export const LineItemsRejectReasonProvider = ({
  children,
}: PropsWithChildren) => {
  const [lineItemsReason, setlineItemsReason] = useState<LineItemRejectReason>(
    {},
  );

  const addLineItemReason = (lineItemId: string) => {
    return function onEditLineItemReason(reason: string) {
      setlineItemsReason((prev) => ({
        ...prev,
        [lineItemId]: { reason },
      }));
    };
  };

  return (
    <LineItemsStateContext.Provider
      value={{
        lineItemsReason,
        addLineItemReason,
      }}
    >
      {children}
    </LineItemsStateContext.Provider>
  );
};

export const useLineItemRejectReasons = () => {
  const context = useContext(LineItemsStateContext);
  if (!context) {
    throw new Error(
      "useLineItemRejectReasonContext must be used within a LineItemsStateProvider",
    );
  }
  return context;
};
